"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = exports.List = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../utils");

var styles = {
  "list": "metadata-list-1oH2K",
  "group": "metadata-group-JUf0S",
  "empty": "metadata-empty-3iOmg"
};

var List = function List(_ref) {
  var children = _ref.children,
      className = _ref.className,
      htmlProps = (0, _objectWithoutProperties2["default"])(_ref, ["children", "className"]);
  return /*#__PURE__*/_react["default"].createElement("dl", (0, _extends2["default"])({
    className: _utils.classNames.use(styles.list).join(className)
  }, htmlProps), children);
};

exports.List = List;
List.displayName = "List";

var Item = function Item(_ref2) {
  var children = _ref2.children,
      label = _ref2.label,
      id = _ref2.id,
      className = _ref2.className,
      itemProp = _ref2.itemProp,
      itemScope = _ref2.itemScope,
      itemType = _ref2.itemType,
      htmlProps = (0, _objectWithoutProperties2["default"])(_ref2, ["children", "label", "id", "className", "itemProp", "itemScope", "itemType"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: _utils.classNames.use(styles.group, children == null && styles.empty).join(className)
  }, htmlProps), /*#__PURE__*/_react["default"].createElement("dt", {
    className: styles.scope,
    id: "".concat(id, "-title")
  }, label), /*#__PURE__*/_react["default"].createElement("dd", (0, _extends2["default"])({
    className: styles.value,
    "aria-labelledby": "".concat(id, "-title")
  }, {
    itemProp: itemProp,
    itemScope: itemScope,
    itemType: itemType
  }), children));
};

exports.Item = Item;
Item.displayName = "Item";
List.displayName = 'MetadataList';
Item.displayName = "".concat(List.displayName, ".Item");
List.Item = Item;
var _default = List;
exports["default"] = _default;